"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOrientation = exports.calculateImageOrientation = exports.calculateLayerOrientation = exports.filterMatchingDesigns = exports.getDesignForAutofill = exports.addImageToLayer = exports.getEnrichedDesigns = void 0;
const UserPhotoLayer_1 = require("../../../models/layers/UserPhotoLayer");
const layers_1 = require("../../layers");
const updatePrintableLayerUserData_1 = __importDefault(require("../updatePrintableLayerUserData"));
const designs_1 = require("../../designs");
const either_1 = require("../../../types/either");
const constants_1 = require("../../designs/constants");
const imageCrop_1 = require("../../../utils/imageCrop");
const getTemplateSurface_1 = require("../../printables/getTemplateSurface");
const getEnrichedDesigns = template => {
  return template.designs.map(design => Object.assign(Object.assign({}, design), {
    layersWithOrientation: design.layers.map(layerId => {
      const layer = template.layers.find(l => l.id === layerId);
      if (!(0, UserPhotoLayer_1.isUserPhotoLayer)(layer)) {
        return layer;
      }
      return Object.assign({
        orientation: (0, exports.calculateLayerOrientation)((0, getTemplateSurface_1.getTemplateSurface)({
          template,
          printableGroupType: 'interior'
        }), layer)
      }, layer);
    })
  }));
};
exports.getEnrichedDesigns = getEnrichedDesigns;
const addImageToLayer = (image, layer, printable, project, timestamp) => {
  const updatedUserData = (0, layers_1.getCropForUserPhotoLayer)(printable.surface, layer, image.galleryId, image.galleryImageId, {
    width: image.width,
    height: image.height
  }, false);
  return (0, updatePrintableLayerUserData_1.default)(project, {
    type: 'UPDATE_PRINTABLE_LAYER_USER_DATA',
    projectId: project.id,
    timestamp,
    printableId: printable.id,
    userData: updatedUserData,
    layerId: layer.id
  });
};
exports.addImageToLayer = addImageToLayer;
const getDesignForAutofill = function (emptyPrintableIdx, autofillableDesigns, availableDesigns, images, randomNumber, restrictToAutofillDesigns) {
  let filters = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  const getDesignResult = (0, designs_1.getBookInteriorDesign)(autofillableDesigns.filter(d => (0, exports.filterMatchingDesigns)(d, images)), emptyPrintableIdx, randomNumber, filters, false);
  if (getDesignResult.isRight()) {
    return (0, either_1.right)(getDesignResult.value);
  }
  if (restrictToAutofillDesigns) {
    return (0, either_1.left)(getDesignResult.value);
  }
  const getDesignResultWithAllDesigns = (0, designs_1.getBookInteriorDesign)(availableDesigns, emptyPrintableIdx, randomNumber, [...filters, constants_1.HAS_IMAGE_FILTER]);
  if (getDesignResultWithAllDesigns.isLeft()) {
    return (0, either_1.left)(getDesignResultWithAllDesigns.value);
  }
  return (0, either_1.right)(getDesignResultWithAllDesigns.value);
};
exports.getDesignForAutofill = getDesignForAutofill;
const filterMatchingDesigns = (design, images) => {
  const layers = design.layersWithOrientation;
  if (!layers.length || images.length < layers.length) {
    return false;
  }
  for (let i = 0; i < layers.length; i++) {
    if (images[i].orientation === 'square') {
      //if the image is square, the layer must be square
      if (layers[i].orientation !== 'square') {
        return false;
      }
    } else {
      //otherwise the image is portrait or landscape, so the layer must match or be square
      if (images[i].orientation !== layers[i].orientation && layers[i].orientation !== 'square') {
        return false;
      }
    }
  }
  return true;
};
exports.filterMatchingDesigns = filterMatchingDesigns;
const calculateLayerOrientation = (surface, layer) => {
  const wellWidth = surface.width * (layer === null || layer === void 0 ? void 0 : layer.width);
  const wellHeight = surface.height * (layer === null || layer === void 0 ? void 0 : layer.height);
  const wellAspectRatio = (0, imageCrop_1.calcAspectRatio)(wellHeight, wellWidth);
  return (0, exports.calculateOrientation)(wellAspectRatio);
};
exports.calculateLayerOrientation = calculateLayerOrientation;
const calculateImageOrientation = (width, height) => {
  const aspectRatio = (0, imageCrop_1.calcAspectRatio)(height, width);
  return (0, exports.calculateOrientation)(aspectRatio);
};
exports.calculateImageOrientation = calculateImageOrientation;
const calculateOrientation = aspectRatio => {
  if (aspectRatio > 1.1) {
    return 'portrait';
  } else if (aspectRatio < 0.9) {
    return 'landscape';
  } else {
    return 'square';
  }
};
exports.calculateOrientation = calculateOrientation;